import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations
import {
	BreakpointWidth
} from '@app/enumerations';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		formAdvisory_formContainer: {

		},
		formAdvisory_titleIconWrapper: {
			display: 'flex',
			marginBottom: theme.spacing(3),
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				justifyContent: 'center',
			},
		},
		formAdvisory_titleIcon: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				fontSize: '10rem',
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				fontSize: '14rem',
			},
		},
		formAdvisory_titleIconPrimary: {
			color: theme.palette.primary[200],
		},
		formAdvisory_titleIconSecondary: {
			color: theme.palette.secondary[200],
		},
		formAdvisory_titleIconWarning: {
			color: theme.palette.warning[200],
		},
		formAdvisory_titleIconError: {
			color: theme.palette.error[200],
		},
		formAdvisory_titleIconInfo: {
			olor: theme.palette.info[200],
		},
		formAdvisory_titleIconSuccess: {
			olor: theme.palette.success[200],
		},
		formAdvisory_title: {
			marginBottom: theme.spacing(3),
			fontSize: theme.typography.h5.fontSize,
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				textAlign: 'center'
			},
		},
		formAdvisory_titlePrimary: {
			color: theme.palette.primary.main,
		},
		formAdvisory_titleSecondary: {
			color: theme.palette.secondary.main,
		},
		formAdvisory_titleWarning: {
			color: theme.palette.warning.main,
		},
		formAdvisory_titleError: {
			color: theme.palette.error.main,
		},
		formAdvisory_titleInfo: {
			color: theme.palette.info.main,
		},
		formAdvisory_titleSuccess: {
			color: theme.palette.success.main,
		},
		formAdvisory_messages: {
			'& > div:last-child': {
				marginTop: theme.spacing(1.5),
			},
			'& > div:first-child': {
				marginBottom: theme.spacing(1.5),
			},
			'& > div:nth-child(n+2):nth-last-child(n+2)': {
				margin: theme.spacing(1.5, 0),
			},
			'& > div:only-child': {
				margin: theme.spacing(0),
			}
		},
		formAdvisory_messageContainer: {
			display: 'flex',
			flexDirection: 'column',
		},
		formAdvisory_message: {
			color: theme.palette.info.main,
			marginBottom: theme.spacing(3),
		},
		formAdvisory_messageBulletinPoints: {
			padding: theme.spacing(0, 0, 0, 2),
			margin: theme.spacing(0),
		},
		formAdvisory_messageBulletinPoint: {
			color: theme.palette.info.main,
			padding: theme.spacing(1, 0),
		},
		formAdvisory_buttons: {
			display: 'inline-flex',
			flexWrap: 'wrap',
			'& > div': {
				margin: theme.spacing(2.5, 3, 2.5, 0)
			},
		}
	});
});

export default useStyles;
